import { IShippingMethod } from '../domain/entities/ShippingMethodsCollection/ShippingMethodsCollection';

export interface IPriceWithTaxConfig {
  displayShippingFeeWithTax: boolean;
  vatPercentage: number;
}

const getPriceWithTax = (
  price: number,
  config: IPriceWithTaxConfig,
): number => {
  const { displayShippingFeeWithTax, vatPercentage } = config;
  if (displayShippingFeeWithTax) {
    return (price * (100 + vatPercentage)) / 100;
  }
  return price;
};

const calculateShippingPriceWithTax = (
  shippingMethods: IShippingMethod[],
  config: IPriceWithTaxConfig,
): IShippingMethod[] => {
  const { displayShippingFeeWithTax } = config;
  if (displayShippingFeeWithTax && shippingMethods?.length) {

    return shippingMethods.map(item => ({
      ...item,
      discount: getPriceWithTax(item.discount || 0, config),
      price: getPriceWithTax(item.price, config),
      totalPrice: getPriceWithTax(item.totalPrice, config),
    }));
  }
  return shippingMethods || [];
};

const getMinimumPrice = (shippingOptions: IShippingMethod[], config?: IPriceWithTaxConfig): number => {
  const items = shippingOptions
    .filter(item => item.totalPrice !== undefined);

  const price = items.length > 0 ? items.reduce((prev, curr) => {
    const isPrevLower = prev && prev.totalPrice < curr.totalPrice;

    return isPrevLower ? prev : curr;
  }).totalPrice : 0;

  return config?.displayShippingFeeWithTax ? getPriceWithTax(price, config) : price;
};

export {
  calculateShippingPriceWithTax,
  getPriceWithTax,
  getMinimumPrice,
};
